import type { HeadingOutline } from '@pepper/utils/src/types/seo'

interface TagObject {
  tag: string
  text: string
  child: TagObject[]
}

export const placeholderHeadingOutline: HeadingOutline[] = [
  { text: '', level: 1 },
  { text: '', level: 2 },
  { text: '', level: 2 }
]

export function convertToTagObject(outline: HeadingOutline[]): TagObject[] {
  const root: TagObject = { tag: 'root', text: '', child: [] }
  const tagObjectsByLevel: Record<number, TagObject[]> = { 1: root.child }
  let currentLevel = 1

  outline.forEach(item => {
    const { level, text } = item
    const validLevel = Math.min(Math.max(level, 1), 7)

    const newItem: TagObject = { tag: `h${validLevel}`, text, child: [] }

    if (!tagObjectsByLevel[validLevel]) {
      tagObjectsByLevel[validLevel] = []
    }

    tagObjectsByLevel[validLevel].push(newItem)

    if (validLevel > 1) {
      // Find the nearest existing level
      let nearestLevel = validLevel - 1
      while (!tagObjectsByLevel[nearestLevel] && nearestLevel > 1) {
        nearestLevel--
      }

      tagObjectsByLevel[nearestLevel].slice(-1)[0].child.push(newItem)
    }

    currentLevel = validLevel
  })

  return root.child
}
